import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStudioDisplay: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"studio-display, thunderbolt"} maskId="square-filled-radius-0-stroke-1-IconStudioDisplay"><path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V18H16V21H8V18H2V4ZM9 18V20H15V18H9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconStudioDisplay;
